var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class BoseVideoBar {
    constructor(log) {
        this.activePreset = 0;
        this.cameraTracking = true;
        this.commandRegEx = /data={"([0-9a-f]+)":"([^\"]*)"}/i;
        this.firmwareVersion = '1.5.1_75ebaa7';
        this.mute = false;
        this.pan = 0;
        this.presets = [
            [0, 0, 1],
            [0, 0, 1],
            [0, 0, 1],
        ]; // stores PTZ values
        this.tilt = 0;
        this.volume = '50';
        this.zoom = 1;
        this.asyncHandlers = [
            {
                name: 'queryValues',
                path: /\/api\?query=(.+)/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    let retValue = '';
                    let preset;
                    switch (match[1]) {
                        case '2': // Mute
                            retValue = this.mute ? '1' : '0';
                            break;
                        case '3': // Volume
                            retValue = this.volume;
                            break;
                        case '6': // Get zoom
                            retValue = this.zoom;
                            break;
                        case '7': // Get pan
                            retValue = this.pan;
                            break;
                        case '8': // Get tilt
                            retValue = this.tilt;
                            break;
                        case '16': // Firmware version
                            retValue = this.firmwareVersion;
                            break;
                        case '19': // Camera tracking
                            retValue = this.cameraTracking ? '1' : '0';
                            break;
                        case '56':
                            preset = this.presets[0];
                            retValue = `${preset[0]} ${preset[1]} ${preset[2]}`;
                            break;
                        case '57':
                            preset = this.presets[1];
                            retValue = `${preset[0]} ${preset[1]} ${preset[2]}`;
                            break;
                        case '58':
                            preset = this.presets[2];
                            retValue = `${preset[0]} ${preset[1]} ${preset[2]}`;
                            break;
                        case 'D6': // Model type
                            retValue = 'vb1';
                            break;
                        default:
                            return this.makeResponse(req, `{"${match[1]}": {"status": "error", "code": "0xe002" }}`);
                            break;
                    }
                    return this.makeResponse(req, `{"${match[1]}": {"value": "${retValue}", "status": "success" }}`);
                }),
            },
            {
                name: 'setValues',
                path: /\/api$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const cmdMatch = this.commandRegEx.exec(req.data);
                    if (cmdMatch) {
                        // Turn off camera tracking on manual camera movement or presets
                        switch (cmdMatch[1]) {
                            case '2': // Mute
                                if (req.method === 'put')
                                    this.mute = cmdMatch[2] === '1';
                                break;
                            case '3': // Volume
                                if (req.method === 'put')
                                    this.volume = cmdMatch[2];
                                break;
                            case '9':
                                if (++this.zoom > 10)
                                    this.zoom = 10;
                                this.cameraTracking = false;
                                break;
                            case '0A':
                                if (--this.zoom < 1)
                                    this.zoom = 1;
                                this.cameraTracking = false;
                                break;
                            case '0B':
                                if (--this.pan < -10)
                                    this.pan = -10;
                                this.cameraTracking = false;
                                break;
                            case '0C':
                                if (++this.pan > 10)
                                    this.pan = 10;
                                this.cameraTracking = false;
                                break;
                            case '0D':
                                if (++this.tilt > 10)
                                    this.tilt = 10;
                                this.cameraTracking = false;
                                break;
                            case '0E':
                                if (--this.tilt < -10)
                                    this.tilt = -10;
                                this.cameraTracking = false;
                                break;
                            case '0F': // apply preset PTZ to the camera
                                [this.pan, this.tilt, this.zoom] = this.presets[this.activePreset];
                                this.cameraTracking = false;
                                break;
                            case '12':
                                this.presets[0] = [this.pan, this.tilt, this.zoom];
                                break;
                            case '13': // set active preset
                                if (req.method === 'put') {
                                    this.activePreset = parseInt(cmdMatch[2]) - 1;
                                }
                            case '17':
                                this.presets[1] = [this.pan, this.tilt, this.zoom];
                                break;
                            case '18': // store preset
                                this.presets[2] = [this.pan, this.tilt, this.zoom];
                                break;
                            case '19': // Camera tracking
                                if (req.method === 'put')
                                    this.cameraTracking = cmdMatch[2] === '1';
                                break;
                            case '56': // set home preset
                                if (req.method === 'put') {
                                    const ptzData = cmdMatch[1];
                                    this.presets[0] = [
                                        parseInt(ptzData[0]),
                                        parseInt(ptzData[1]),
                                        parseInt(ptzData[2]),
                                    ];
                                }
                                break;
                            case '57': // set preset 1
                                if (req.method === 'put') {
                                    const ptzData = cmdMatch[1];
                                    this.presets[1] = [
                                        parseInt(ptzData[0]),
                                        parseInt(ptzData[1]),
                                        parseInt(ptzData[2]),
                                    ];
                                }
                                break;
                            case '58': // set preset 2
                                if (req.method === 'put') {
                                    const ptzData = cmdMatch[1];
                                    this.presets[2] = [
                                        parseInt(ptzData[0]),
                                        parseInt(ptzData[1]),
                                        parseInt(ptzData[2]),
                                    ];
                                }
                                break;
                            default:
                                return this.makeResponse(req, `{"${cmdMatch[1]}": {"status": "error", "code": "0xe002" }}`);
                                break;
                        }
                        return this.makeResponse(req, `{"${cmdMatch[1]}": {"code": "0xe000", "status": "success" }}`);
                    }
                    return this.makeResponse(req, `{"FF": {"status": "error", "code": "0xe002" }}`);
                }),
            },
        ];
    }
    makeResponse(request, result) {
        return {
            status: 200,
            headers: {
                'okhttp-response-source': 'NETWORK 200',
                'keep-alive': 'timeout=60',
                'content-length': `'${result.length}'`,
                'cache-control': 'no-store',
                'okhttp-selected-protocol': 'http/1.1',
                'content-type': 'text/plain',
            },
            data: result,
        };
    }
}
BoseVideoBar.emulatorType = 'httpRequestEmulator';
BoseVideoBar.key = '-Ng-zCfhKcYaq0xdoMH_';
